export enum WealthOverviewEntrySource {
    DIAS = 'DIAS',
    PCM_CORE = 'PCM_CORE',
}
